import { Fragment, useState, useEffect, useRef } from 'react'
import callApi from '../../helpers/callapi'
import CONSTANTS from '../../constants/constants'
import { useDispatch } from 'react-redux'
import config from '../../config'

import { Form, Card, Modal, Button, Row, Col, Table } from 'react-bootstrap'

const TransferMhee = () => {
  const BANK = CONSTANTS.banks
  const bankRef = useRef(null)
  const bankNoRef = useRef(null)
  const amountRef = useRef(null)
  const [showConfirmed, setShowConfirmed] = useState(false)
  const [checkPayOuts, setCheckPayOuts] = useState({})
  const dispatch = useDispatch()
  const [isDisabled, setIsDisabled] = useState(false)

  const payOutsCheck = async () => {
    try {
      dispatch({ type: 'loading_show' })
      const result = await callApi({
        fullURL: `${config.urlHost}/payOuts/inquire`,
        method: 'post',
        body: {
          bankName: bankRef.current.value,
          bankNumber: bankNoRef.current.value,
          amount: amountRef.current.value,
        },
      })
      setCheckPayOuts(result)
      if (result.status) {
        setIsDisabled(true)
      }
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      alert('error')
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }
  const payOutsClick = async () => {
    try {
      dispatch({ type: 'loading_show' })
      await callApi({
        fullURL: `${config.urlHost}/payOuts`,
        method: 'post',
        body: {
          accountName: checkPayOuts.PromptPayAccountName,
          accountNumber: checkPayOuts.PromptPayAccountNo,
          bankCode: checkPayOuts.ToBankID,
          amount: amountRef.current.value,
          note: '',
          round: 3,
          payNow: true,
        },
      })
      bankRef.current.value = ''
      bankNoRef.current.value = ''
      amountRef.current.value = ''
      setCheckPayOuts({})
      setIsDisabled(false)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      alert('error')
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>โอนเงิน</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>ธนาคาร</Form.Label>
                <select className="form-control" style={{ color: '#5d5d5d' }} ref={bankRef} disabled={isDisabled}>
                  <option value="">select...</option>
                  {Object.keys(BANK).map((key, i) => {
                    return (
                      <option value={key} key={i}>
                        {BANK[key]}
                      </option>
                    )
                  })}
                </select>
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>เลขบัญชี</Form.Label>
                <input
                  className="form-control"
                  style={{ color: '#5d5d5d' }}
                  type="text"
                  placeholder="เลขบัญชี"
                  ref={bankNoRef}
                  disabled={isDisabled}
                />
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>จำนวนเงิน</Form.Label>
                <input
                  className="form-control"
                  style={{ color: '#5d5d5d' }}
                  type="text"
                  placeholder="จำนวนเงิน"
                  ref={amountRef}
                  disabled={isDisabled}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-3">
            <Button variant="warning light" onClick={() => payOutsCheck()}>
              ตรวจสอบ
            </Button>
            {checkPayOuts.status === false && <span className="text-danger ml-4">ข้อมูลไม่ถูกต้อง</span>}
            {bankRef && bankRef.current && bankRef.current.value !== '' && checkPayOuts.status === true && (
              <span className="text-success ml-4">
                ข้อมูลถูกต้อง
                <span className="text-dark">
                  {' '}
                  (ชื่อ: {checkPayOuts.PromptPayAccountName}, ธนาคาร: {bankRef.current.value}, เลขบัญชี:{' '}
                  {checkPayOuts.PromptPayAccountNo})
                </span>
              </span>
            )}
          </div>
          <div className="mt-4 text-center">
            {checkPayOuts.status === true ? (
              <Button variant="primary light" onClick={() => setShowConfirmed(true)}>
                โอนเงิน
              </Button>
            ) : (
              <Button variant="primary light" disabled="disabled">
                โอนเงิน
              </Button>
            )}
          </div>
        </Card.Body>

        <Modal show={showConfirmed} centered>
          <Modal.Header>
            ยืนยันการโอนเงิน ?
            <Button variant="" className="close" onClick={() => setShowConfirmed(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            {bankRef && bankRef.current && bankRef.current.value !== '' && checkPayOuts.status === true && (
              <div>
                <div>ชื่อ: {checkPayOuts.PromptPayAccountName}</div>
                <div>ธนาคาร: {bankRef.current.value}</div>
                <div>เลขบัญชี: {checkPayOuts.PromptPayAccountNo}</div>
                <div>จำนวนเงิน: {amountRef.current.value} บาท</div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger light" onClick={() => setShowConfirmed(false)}>
              ยกเลิก
            </Button>
            <Button
              variant="primary light"
              onClick={() => {
                payOutsClick()
                setShowConfirmed(false)
              }}
            >
              ยืนยัน
            </Button>
          </Modal.Footer>
        </Modal>
      </Card>
    </Fragment>
  )
}
export default TransferMhee
